import type { ReactNode } from 'react';

import { Sidebar, SidebarInset, SidebarProvider } from '@nesso/ui/primitives/sidebar';

import { useGenerationUpdates } from '@/entities/session';

import { TodaySessionsContent } from './today-sessions/today-sessions-content';
import { TodaySessionsMobileTrigger } from './today-sessions/today-sessions-mobile-trigger';
import { TodaySessionsSheet } from './today-sessions/today-sessions-sheet';
import { TodaySessionsSidebar } from './today-sessions/today-sessions-sidebar';

export function TodaySessions({ children }: Readonly<{ children: ReactNode }>) {
    useGenerationUpdates();

    return (
        <div className="h-full bg-background overflow-hidden flex flex-col">
            <SidebarProvider className="h-full min-h-0">
                <Sidebar className="md:top-16 md:h-[calc(100svh-4rem)]">
                    <TodaySessionsSidebar>
                        <TodaySessionsContent />
                    </TodaySessionsSidebar>
                </Sidebar>
                <SidebarInset>
                    {children}
                    <TodaySessionsMobileTrigger />
                </SidebarInset>
                <TodaySessionsSheet>
                    <TodaySessionsContent />
                </TodaySessionsSheet>
            </SidebarProvider>
        </div>
    );
}
